import React, { useState } from 'react';
import {Card, CardBody, Row, Col, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {formatModifyDate} from "../../../components/Common/CommonLogic";
import {featuretime} from "../../../assets/images";

const TrackingTimelineModal = ({ isOpen, toggle , trackingEvents, searchContainerData }) => {
    //console.log(searchContainerData, "TrackingTimelineModal")
    const current = Date.now();
    return (
        <>
            <Modal isOpen={isOpen} toggle={toggle} className="modal-md-custom" centered scrollable={true}>
                <ModalHeader toggle={toggle}>
                    {searchContainerData?.container?.number} ETA: {formatModifyDate(searchContainerData?.pod?.eta_date)}
                </ModalHeader>
                <ModalBody>
                    <div className="mt-4 d-flex flex-column align-items-start">
                        <div className="mb-4 text-start" >
                            <div className="text-muted">Updated at: {formatModifyDate(searchContainerData?.timeStamp)}</div>
                            <h5 className="fw-bold mt-2">
                                {(searchContainerData?.origin?.port != '' && searchContainerData?.origin?.country != '') && (
                                    <>
                                        <i className="bx bx-home-alt me-2"></i> {searchContainerData?.origin?.port}, {searchContainerData?.origin?.country}
                                    </>
                                )}
                            </h5>
                        </div>

                        <div className="mt-3">
                            <div className="w-100">
                                <ul className="verti-timeline timeline-list-unstyled timeline_map">
                                    {trackingEvents.map((item, index) =>
                                        (item?.location?.port !== '' && item?.location?.country !== '') && (

                                            <li key={index} className="event-list">
                                                <div className="event-timeline-dot">
                                                    <i className={`bx bx-right-arrow-circle ${item?.event_recent ? 'bx-fade-right' : ''}`}></i>
                                                </div>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 me-5">
                                                        {console.log(current, "current dat", item?.event_date, "event date")}
                                                        {(new Date(item?.event_date).getTime() <= current) ?
                                                            <i className="bx bx-check-circle h2 tracking-info-icon"></i>
                                                            : <i className="bx bx-check-circle h2 tracking-info-icon-blur"></i>
                                                        }
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <div>
                                                            <span>
                                                                {item?.location?.port}, {item?.location?.country}
                                                                <br />
                                                                <small>{item?.location?.terminal}</small>
                                                                <br />
                                                            </span>
                                                            <small>{item?.action?.action_name} {item?.mode?.transport_mode}</small>
                                                            <br />
                                                            <span>{item?.event_date && formatModifyDate(item.event_date)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}


export default TrackingTimelineModal;
